import {
  Flexbox, Form, Mask, QuickFilter,
} from '@/components'
import React from 'react'

function CastrationsRegistryQuickFilter() {
  return (
    <QuickFilter
      initialValues={{
        'tutor.fullName_cont': '',
        'tutor.documentNumber_eq': '',
        'tutor.phoneNumber_eq': '',
      }}
      title="Filtrar"
      renderForm={({ setFieldValue }) => (
        <>
          <Flexbox.Column className="col-3 mt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="tutorFullName">
                Nome do solicitante
              </Form.Label>
              <Form.ValidationField
                name="['tutor.fullName_cont']"
                className="input-sm"
                id="tutorFullName"
                autoComplete="none"
                placeholder="Fulano da Silva"
              />
            </Form.Group>
          </Flexbox.Column>
          <Flexbox.Column className="col-3 mt-2">
            <Form.Group>
              <Form.Label
                className="label-sm pt-2"
                htmlFor="tutorDocumentNumber"
              >
                CPF/CNPJ do solicitante
              </Form.Label>
              <Form.ValidationField name="['tutor.documentNumber_eq']">
                {({ field }) => (
                  <Mask.CpfCnpj
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    className="input-sm"
                    placeholder="CPF/CNPJ do tutor"
                    id="tutorDocumentNumber"
                    onAccept={(value) => {
                      setFieldValue("['tutor.documentNumber_eq']", value)
                    }}
                  />
                )}
              </Form.ValidationField>
            </Form.Group>
          </Flexbox.Column>
          <Flexbox.Column className="col-3 mt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="tutorPhoneNumber">
                Telefone do solicitante
              </Form.Label>
              <Form.ValidationField name="['tutor.phoneNumber_eq']">
                {({ field }) => (
                  <Mask.Phone
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    className="input-sm"
                    placeholder="Número do telefone"
                    id="tutorPhoneNumber"
                    onAccept={(value) => {
                      setFieldValue("['tutor.phoneNumber_eq']", value)
                    }}
                  />
                )}
              </Form.ValidationField>
            </Form.Group>
          </Flexbox.Column>
        </>
      )}
    />
  )
}

export default CastrationsRegistryQuickFilter
